import closeCompose from '../actions/closeCompose';
import datapoints from '../datapoints';
import ComposeViewState, { ComposeOperation } from '../store/schema/ComposeViewState';
import { uiLessAddinIsRunning } from '../utils/blockOnNavigation';
import { ComposeScenario, logSmartReplyDatapoint } from '../utils/logSmartReplyComposeDatapoint';
import safelyGetSmartReplyExtractionId from '../utils/safelyGetSmartReplyExtractionId';
import { isViewStateDirty } from '../utils/viewStateUtils';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import endSession from 'owa-controls-findpeople-feedback-manager/lib/actions/endSession';
import deleteItemService from 'owa-mail-store/lib/services/deleteItemService';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import logDiscardActionMailTipsDatapoint from '../utils/logDiscardActionMailTipsDatapoint';
import { getAllRecipients } from '../utils/getAllRecipientsAsEmailAddressStrings';
import getMailTipsViewStateMap from '../utils/getMailTipsViewStateMap';

function deleteDraft(viewState: ComposeViewState) {
    if (viewState && viewState.itemId) {
        deleteItemService([viewState.itemId], 'MoveToDeletedItems');
    }

    endSession(viewState.findPeopleFeedbackManager, 'Discard');
    closeCompose(viewState);
}

export default action('discardCompose', datapoints.ComposeCommandDiscardCompose)(
    function discardCompose(viewState: ComposeViewState, doNotConfirm?: boolean) {
        // No need to show confirm dialog when the viewState is not dirty and
        // (No draft created for this viewState, or draft is never saved since created),
        // Or there is no running uiless add-in
        const resolveImmediately =
            doNotConfirm ||
            (!isViewStateDirty(viewState) &&
                (!viewState.itemId ||
                    (viewState.operation != ComposeOperation.EditDraft &&
                        !viewState.lastSaveTimeStamp)) &&
                !uiLessAddinIsRunning(viewState));

        return confirm(
            strings.confirmDiscardText,
            strings.confirmDiscardSubText,
            resolveImmediately,
            {
                // Wait until dialog is dismissed to avoid focus interruption
                delayCallbackAfterAnimation: true,
            }
        ).then((response: DialogResponse) => {
            if (response === DialogResponse.ok) {
                logDiscardActionMailTipsDatapoint(
                    getMailTipsViewStateMap(viewState.ccRecipientWell, getAllRecipients(viewState))
                );
                deleteDraft(viewState);
            }

            // If we are discarding a message created via smart reply, log a datapoint.
            logSmartReplyDatapoint(
                ComposeScenario.Discard,
                safelyGetSmartReplyExtractionId(viewState)
            );
        });
    }
);
